// Age groups

export const AgeGroupTypes = {
  U: 'U', // birthdate + cutoff
  GRADE: 'GRADE', // by school grade
  HS: 'HS', // JV/Varsity/No seniors, etc.
};

export const AgeGroups = {
  U8: { type: AgeGroupTypes.U, label: '8U', value: 8, order: 8 },
  U9: { type: AgeGroupTypes.U, label: '9U', value: 9, order: 9 },
  U10: { type: AgeGroupTypes.U, label: '10U', value: 10, order: 10 },
  U11: { type: AgeGroupTypes.U, label: '11U', value: 11, order: 11 },
  U12: { type: AgeGroupTypes.U, label: '12U', value: 12, order: 12 },
  U13: { type: AgeGroupTypes.U, label: '13U', value: 13, order: 13 },
  U14: { type: AgeGroupTypes.U, label: '14U', value: 14, order: 14 },
  U15: { type: AgeGroupTypes.U, label: '15U', value: 15, order: 15 },
  U16: { type: AgeGroupTypes.U, label: '16U', value: 16, order: 16 },
  HS_NO_SENIORS: {
    type: AgeGroupTypes.HS,
    label: 'High School (no seniors)',
    order: 100,
  },
};

export const groupByLabel = (label) =>
  Object.values(AgeGroups).find((a) => a.label === label);

export const valueByLabel = (label) =>
  Object.values(AgeGroups).find((a) => a.label === label)?.value;

export const ageLabels = Object.values(AgeGroups)
  .sort((a, b) => a.order - b.order)
  .map((g) => g.label);
